export default __webpack_public_path__ + "static/media/icn-arrow-close.d709c38a.svg";